// saga.ts
import { call, put, takeEvery } from 'redux-saga/effects';
import { createProduct, deleteProduct, getProductApi, updateProduct } from '../../api/ProductApi'; // Adjust the path as needed
import {
    getProductSuccess,
    getProductFailure,
    createProductSuccess,
    createProductFailure,
    updateProductSuccess,
    updateProductFailure,
    deleteProductSuccess,
    deleteProductFailure,
} from './actions';

// Saga to handle fetching Products
function* fetchProductSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(getProductApi, action.payload);
        yield put(getProductSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';

        yield put(getProductFailure(errorMessage));
    }
}

// // Saga to handle creating a Product
function* createProductSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(createProduct, action.payload);
        yield put(createProductSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';

        yield put(createProductFailure(errorMessage));
    }
}

// // Saga to handle updating a Product
function* updateProductSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(updateProduct, action.payload.data, action.payload.id);
        yield put(updateProductSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';

        yield put(updateProductFailure(errorMessage));
    }
}

// // Saga to handle updating a Product
function* deleteProductSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(deleteProduct, action.payload.id);
        yield put(deleteProductSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';
        yield put(deleteProductFailure(errorMessage));
    }
}

export default function* ProductSaga() {
    yield takeEvery('GET_PRODUCT_REQUEST', fetchProductSaga);
    yield takeEvery('CREATE_PRODUCT_REQUEST', createProductSaga);
    yield takeEvery('UPDATE_PRODUCT_REQUEST', updateProductSaga);
    yield takeEvery('DELETE_PRODUCT_REQUEST', deleteProductSaga);
}
